export default __webpack_public_path__ + "static/media/pptSlideCornerLogo.c0d29865.png";